import { PreventiveRecallListSettingsContainerState } from "@/Portfolio/Components/PreventiveRecallListSettingsContainer";

enum SearchSettingsDatesOptionsEnum {
    EndOfFiscalYear = 1,
    AsOfToday,
    Personalized
}

class PreventiveRecallListSearchSettings {
    public ShowAllProviders: boolean;
    public IncludeNonEnrolledPatients: boolean;
    public SelectedDateOption: SearchSettingsDatesOptionsEnum;
    public DateFrom: Date;
    public DateTo: Date;
    public ShowAllSites: boolean;
    public ProviderIds: string[];
    public SiteIds: string[];
    public PreventiveCareCriteriaId: string;

    public constructor(init?: Partial<PreventiveRecallListSearchSettings>) {
        Object.assign(this, init);
    }

    public static fromModel(model: PreventiveRecallListSettingsContainerState): PreventiveRecallListSearchSettings {
        const helper = cacheStore.Helper;

        return new PreventiveRecallListSearchSettings({
            ShowAllProviders: model.showAllProviders,
            ShowAllSites: model.showAllSites,
            DateFrom: cacheStore.Helper.CreateDateAsUTC(model.dateFrom),
            DateTo: cacheStore.Helper.CreateDateAsUTC(model.dateTo),
            IncludeNonEnrolledPatients: model.includeNonEnrolledPatients,
            SelectedDateOption: model.selectedDateOption,
            ProviderIds: model.globalProvidersList.filter(provider => provider.Checked).map(p => p.ContactFacetId),
            SiteIds: helper.GetCheckedItemsFromICheckableList(model.sites.toImmutable()).map(p => p.Id).toArray(),
            PreventiveCareCriteriaId: model.PreventiveCareCriteriaId
        });
    }
}

export { PreventiveRecallListSearchSettings, SearchSettingsDatesOptionsEnum };
